export const overlapOpen = (open,id) => {
    return {
        type: 'CANDIDATE_OPEN',
        open: open,
        candidate_id: id,
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/PrevNextButtons/actions.js